import seals from '@ahd/shared/maps/seals/map';
import isUndefinedNullOrEmpty from '@ahd/shared/tools/is-undefined-null-or-empty';
import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntSiegel: (Pick<SelectDataObject, 'icon' | 'iconAutoSizeHeight' | 'img' | 'imgRatio' | 't'> & { i: number; mobileId: string })[] = seals?.filter((s) => !isUndefinedNullOrEmpty(s?.iCars))?.map((s) => ({
    i: s?.iCars,
    icon: s?.icon,
    iconAutoSizeHeight: '1em',
    img: s?.img,
    imgRatio: s?.imgRatio,
    mobileId: s?.i,
    t: s?.t,
}));

export default sIntSiegel;
